import {Pipe, PipeTransform} from '@angular/core';
import {CartItem, CartItemType} from "../../_core/state/cart/cart.model";
import {JobStatus} from "../../../../../api/src/encode/encode-job.entity";

@Pipe({
  name: 'canBeApproved'
})
export class CanBeApprovedPipe implements PipeTransform {

	transform(item: CartItem): boolean{
		if (!item) {
			return false;
		}
		if (item.type == CartItemType.VIDEO) {
			if (item.encodeJob?.tag == 'export') {
				return true;
			}
			return item.encodeJob?.status === JobStatus.Completed;
		} else {
			return true;
		}
	}

}
